import { MaskedLines, Reveal, PrimaryButton, GhostButton, scrollToId } from "./shared";
import { LightArt } from "./LightArt";

export const CtaSection = () => (
    <section data-testid="cta-section" className="relative overflow-hidden border-t border-white/5 bg-black py-40 md:py-56">
        <LightArt variant="halo" hue="warm" className="absolute inset-0 opacity-50" />
        <div className="relative mx-auto max-w-[1400px] px-6 text-center md:px-12">
            <h2 className="font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight text-[#F4F2EF] sm:text-6xl lg:text-8xl">
                <MaskedLines lines={["Have a space that needs", "something extraordinary?"]} />
            </h2>
            <Reveal delay={0.3}>
                <p className="mx-auto mt-10 font-display text-2xl font-bold uppercase tracking-tight text-[#FFE8B6] text-glow-warm md:text-4xl">
                    Let's make it move.
                </p>
            </Reveal>
            <Reveal delay={0.45} className="mt-14 flex flex-wrap justify-center gap-4">
                <PrimaryButton testId="cta-start-project" onClick={() => scrollToId("contact")}>Start a project</PrimaryButton>
                <GhostButton testId="cta-talk-to-studio" onClick={() => scrollToId("contact")}>Talk to the studio</GhostButton>
            </Reveal>
        </div>
    </section>
);
